import React, { useState, useEffect, useContext, useRef } from "react";
import Button from "../../../components/_default/Button";
import DefineMedia from "../../../components/_default/DefineMedia";
import Input from "../../../components/_default/Input";
import {
  addExerciseAurum,
  addExerciseCoach,
  addProgramAurum,
  addProgramCoach,
  addProgramWorkoutAurum,
  addProgramWorkoutCoach,
  addTag,
  addWorkoutAurum,
  addWorkoutCoach,
} from "../../../services/firebase/firestore/saveData";
import VideoPlayer from "../../../components/_default/VideoPlayer";
import MusclesBack from "../../../components/_exercises/MusclesBack";
import MusclesFront from "../../../components/_exercises/MusclesFront";
import MusclesHearth from "../../../components/_exercises/MusclesHearth";
import { createBrowserHistory } from "history";

import "./DefineProgram.scss";
import {
  getProgramsCoach,
  getProgramsWorkoutAurum,
  getProgramsWorkoutCoach,
  getTags,
  getWorkoutsAurum,
  getWorkoutsCoach,
} from "../../../services/firebase/firestore/getData";
import {
  updateExerciseAurum,
  updateExerciseCoach,
  updateProgramAurum,
  updateProgramCoach,
  updateProgramWorkoutAurum,
  updateProgramWorkoutCoach,
  updateWorkoutAurum,
  updateWorkoutCoach,
} from "../../../services/firebase/firestore/updateData";
import { deleteMediaArrayFromStorage } from "../../../services/firebase/storage";
import isIterable from "../../../services/defaultFunctions/isIterable";
import UserContext from "../../../services/context/userContext";
import Header from "../../../components/_default/Header";
import Textarea from "../../../components/_default/Textarea";
import LongList from "../../../components/_default/LongList";
import AddButton from "../../../components/_default/AddButton";
import Popup from "../../../components/_default/Popup";
import {
  deleteProgramWorkoutAurum,
  deleteProgramWorkoutCoach,
} from "../../../services/firebase/firestore/deleteData";
import { storage } from "../../../services/firebase/firebase";
import VideoImageThumbnail from "react-video-thumbnail-image";
// import Dropdown from 'react-dropdown';
// import 'react-dropdown/style.css';
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Icon from "../../../components/_default/Icon";
// import DropDown from "../../../components/_default/DropDown";
import {IoAddCircle,IoAddCircleOutline} from "react-icons/io5"
import SnackBar from 'my-react-snackbar';
function DefineProgram(props) {
  const categories = [
    "Upper",
    "Lower",
    "Mobility Drills",
    "Cardio",
    "Corrective Exercise Protocol",
  ];
  const starts_with_options = ["Up", "Down"];
  let [phases, setPhases] = useState(1); //useState(1)
  const [weeks, setWeeks] = useState(1); //useState(1)
  const [phaseArr, setPhaseArr] = useState([]);
  const [initialTags, setInitialTags] = useState([]);
  const [workouts, setWorkouts] = useState(false);
  // const [activePhase, setActivePhase] = useState(false);
  // const [activePhase, setActivePhase] = useState(false);
  const [activePhase, setActivePhase] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDuplicate, setLoadingDuplicate] = useState(false);
  const [openVideoModal, setOnVideoModal] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleteUrlArray, setDeleteUrlArray] = useState(false);
  const [videoPath, setVideoPath] = useState("");
  const [addWorkout, setAddWorkout] = useState(false);
  const [thumbnailPath, setThumbnailPath] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [allWorkouts, setAllWorkouts] = useState([]);
  const [allWorkoutsTitles, setAllWorkoutsTitles] = useState([]);
  const [addWorkoutDrop, setAddWorkoutDrop] = useState([]);
  const [reloadWorkout, setReloadWorkout] = useState(false);
  const [weekChanged, setWeekChanged] = useState(false);
  const [phaseChanged, setPhaseChanged] = useState(false);
  let [phaseName, setPhaseName] = useState("");
  let [phasesArrayOfObj, setPhasesArrayOfObj] = useState([]);
  const [inputs, setInputs] = useState([{ phase: "", value: "" }]);
  const [isProgramId,setIsProgramId]=useState(false)
  const [phase, setPhase] = useState("");
  const [phasesWithName, setPhaseWithName] = useState([]);
  const [open,setOpen]=useState(false)
  const [snackbarMessage,setSnackbarMessage]=useState("")
  let snapshots = [];
  const SnackBarStyle={
    backgroundColor: "rgb(0, 189, 165)",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    position: "fixed",
    textAlign: "center",
    width: "213px",
    height: "40px",
    fontSize: "15px",
    fontWeight: "600",
    zIndex: "10000",
    boxShadow: "rgb(0, 189, 165,0.3) 0px 1px 14px 0px",
    padding: "3px",
    color: "white",
    borderRadius: "5px",
    transition: "all 1s ease 0s",
    opacity: "1",
    top: "20px",
    right: "20px",

  }
  const user = useContext(UserContext);
  const from = props.location.state.from;
  const isAdmin = !(
    from === "aurum" &&
    !user.admin &&
    props?.location?.state?.update
  );

  // console.log("from val in program_page",from)
  const inputHandler = (text, key) => {
    const _inputs = [...inputs];
    _inputs[key].value = text;
    _inputs[key].phase = key + 1;
    // _inputs[key].key =  key;
    // console.log("pashe arr with naeme", phaseArr[key] + _inputs[key].value);
    // debugger
    // console.log("inputs", inputs);
    setInputs(_inputs);
    let phaseName = phaseArr[key] + " " + _inputs[key].value;
    let arrPhase = phaseName.split(" ");
    let phasesWithNames =
      arrPhase[0] +
      arrPhase[1] +
      arrPhase[2] +
      arrPhase[3] +
      "(" +
      arrPhase[arrPhase.length - 1] +
      ")";

    // console.log("filter phase with val",phasesWithNames)
    let dataArr = [];
    console.log(
      "phasename",
      // phaseArr.map((data, i) => ({ id: i + 1, value: `${data} ${inputs[i]?.value }`}))
      phaseArr.map((data, i) => ({
        id: i + 1,
        value: `${data} ${inputs[i]?.value}`,
      }))
    );
    // phaseArr.map((data,i)=>{
    //   phaseArr.splice(key,1,data+inputs[i]?.value )
    // })
    // console.log("obj to aarr", phaseArr);
    // phaseArr.splice(key,1,phasesWithNames?.toString())
    const finalArray = phaseArr?.map((data, i) => ({
      id: i + 1,
      value: `${data} ${inputs[i]?.value}`,
    }));
    // console.log("active phase", finalArray);

    var final = finalArray.map(function (obj) {
      return obj.value;
    });

    // console.log("finanana", final);
    // setPhaseArr(final)
  };

  useEffect(() => {
    let _program = props.location.state.program;
    if (from === "coach" || !user.admin) {
      getWorkoutsCoach(user?.id, (result) => {
        setAllWorkouts(result);
        let titles = [];
        // console.log(result);
        result.forEach((element) => {
          titles.push(element.name);
        });
        setAllWorkoutsTitles(titles);
      });

      getProgramsCoach(user?.id,(result)=>{
        // console.log("ressssuu",result)
        let filter=result.filter((program)=>program.id==_program.id)
        // console.log("resssuu",filter[0])
        setName(filter[0]?.name);
        setDescription(filter[0]?.description);
        setWeeks(weekChanged ? weekChanged : filter[0]?.weeks);
        setPhases(phaseChanged ? phaseChanged : filter[0]?.phases);
        setImage(filter[0]?.image);
        // setInputs(_program.phasesNames ? _program.phasesNames : "");
        setPhase(filter[0]?.phasesWithNames ? filter[0]?.phasesWithNames[0]?.phaseName : "");
        setPhaseWithName(filter[0].phasesWithNames ? filter[0].phasesWithNames:"")
        setPhaseArr(filter[0]?.phaseArr ? filter[0]?.phaseArr : []);
        // console.log("__program__update", _program.phasesWithNames);
      })
    } else {
      getWorkoutsAurum((result) => {
        setAllWorkouts(result);
        let titles = [];
        if (result) {
          result.forEach((element) => {
            titles.push(element.name);
          });
        }

        setAllWorkoutsTitles(titles);
      });
    }

   
    if (props.location.state.update || props.location.state.copy) {
      // console.log("_program",_program,props.location.state)
      setName(_program.name);
      setDescription(_program.description);
      setWeeks(weekChanged ? weekChanged : _program.weeks);
      setPhases(phaseChanged ? phaseChanged : _program.phases);
      setImage(_program.image);
      // setInputs(_program.phasesNames ? _program.phasesNames : "");
      setPhase(_program.phasesWithNames ? _program.phasesWithNames[0]?.phaseName : "");
      setPhaseWithName(_program.phasesWithNames ? _program.phasesWithNames:"")
      setPhaseArr(_program.phaseArr ? _program.phaseArr : "");
      // console.log("__program__update", _program.phasesWithNames);
      if (_program.phasesWithNames) {
        localStorage.setItem(
          "phasesArr",
          JSON.stringify(_program.phasesWithNames)
        );
      } else {
        JSON.parse(localStorage.getItem("phasesArr") || `[]`);
      }
      // setPhaseName(phaseName?phaseName:_program.phase?_program.phase.phaseName:"")
      // setWorkouts(_program.workouts);
      setLoadingDuplicate(false);
      //window.scrollTo({top: 0, behavior: 'smooth'});
    }
    setUpdate(props.location.state.update);
    getTags((tags) => {
      setInitialTags(tags);
    });
  }, [props.location.state]);

  useEffect(() => {
    // let arr = [];
    // console.log('jow', weeks, phases);
    // var size = Math.round(((weeks * phases)-1) / phases);
    // for (let i = 0; i < phases; i++) {
    //   var inf = i * size;
    //   var sup = inf + size < (weeks * phases) ? inf + size + 1: (weeks * phases);

    //   if(inf === 0){
    //     inf++
    //   }

    let arr = [];
    let _weeks = Math.round(weeks);
    let _phases = Math.round(phases);
    let w_first = 1;
    let w_last = _weeks;
    //arr.push('weeks '+ w_first + ' - ' + w_last);
    for (let i = 1; i <= phases; i++) {
      w_last = _weeks * i;
      arr.push("Week " + w_first + " - " + w_last);
      // arr.push(phaseName +" "+ w_first + ' - ' + w_last);
      w_first = w_first + _weeks;
    }
    //arr.push('weeks '+ inf + ' - ' + sup);
    //}
    setPhaseArr(arr);
    setActivePhase(arr[0]);
  }, [weeks, phases, reloadWorkout]);
  // useEffect(() => {
  // //  const setData= localStorage.getItem("phasesArr")||[]
  //   // let arr = [];
  //   // console.log('jow', weeks, phases);
  //   // var size = Math.round(((weeks * phases)-1) / phases);
  //   // for (let i = 0; i < phases; i++) {
  //   //   var inf = i * size;
  //   //   var sup = inf + size < (weeks * phases) ? inf + size + 1: (weeks * phases);

  //   //   if(inf === 0){
  //   //     inf++
  //   //   }

  //   let arr = [];
  //   let _weeks = Math.round(weeks);
  //   let _phases = Math.round(phases);
  //   let w_first = 1;
  //   let w_last = _weeks;
  //   //arr.push('weeks '+ w_first + ' - ' + w_last);

  //   for (let i = 1; i <= phases; i++) {
  //     w_last = _weeks * i;

  //     arr.push("Week " + w_first + " - " + w_last);

  //     console.log("arr",arr)

  //     w_first = w_first + _weeks;
  //   }
  //   //arr.push('weeks '+ inf + ' - ' + sup);
  //   //}

  // //  console.log("hsjdhd",phaseArr)
  //   setPhaseArr(arr);

  //   setActivePhase(arr[0])
  // }, [weeks, phases, reloadWorkout]);

  // const handelPhaseName=(e)=>{

  //   let arr = [];
  //     let _weeks = Math.round(weeks);
  //     let _phases = Math.round(phases);
  //     let w_first = 1;
  //     let w_last = _weeks;
  //     //arr.push('weeks '+ w_first + ' - ' + w_last);
  //     for(let i = 1; i <= phases; i++){
  //       w_last = _weeks*i;
  //       // arr.push('Week '+ w_first + ' - ' + w_last);
  //       arr.push(phaseName +" "+ w_first + ' - ' + w_last);
  //       w_first = w_first+_weeks;
  //     }
  //     //arr.push('weeks '+ inf + ' - ' + sup);
  //   //}
  //   setPhaseArr(arr);
  //   setActivePhase(arr[0])
  // }

  useEffect(() => {
    debugger
    console.log("relaod workout use effect is running")
    if (from === "coach" || !user.admin) {
      getProgramsWorkoutCoach(
        user?.id,
        isProgramId?isProgramId:props?.location?.state?.program?.id,
        (result) => {
          if (result) {
            setWorkouts(result.filter((item) => item.phase === activePhase));
          }
        }
      );
    } else {
      getProgramsWorkoutAurum(props?.location?.state?.program?.id, (result) => {
        if (result) {
          setWorkouts(result.filter((item) => item.phase === activePhase));
        }
      });
    }
  }, [activePhase, reloadWorkout]);

  const addToDeleteUrl = (pageType, url) => {
    let _deleteUrlArray = isIterable(deleteUrlArray) ? [...deleteUrlArray] : [];
    _deleteUrlArray.push(url);
    setDeleteUrlArray(_deleteUrlArray);
  };

  const toggleModal = (modalIsOpened, url, thumbnail) => {
    setVideoPath(url);
    setThumbnailPath(thumbnail);

    setOnVideoModal(!openVideoModal);
  };

  function initiateLoading(type, value) {
    if (type === "duplicate") {
      setLoadingDuplicate(value);
    } else {
      setLoading(value);
    }
  }

  function onSubmit(duplicate, addWorkout, submitWorkout, noRefresh) {
    
    setWeekChanged(false);
    setPhaseChanged(false);
    initiateLoading(duplicate ? "duplicate" : "save", true);
    if (name === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "name", message: "Add a name for your program." });
    } else if (description === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({
        type: "description",
        message: "Add a short program description for your exercise.",
      });
    } else {
      setError(false);
      const _program = {
        name: name,
        description: description,
        phases: phases,
        // phasesNames: inputs,
        weeks: weeks,
        image: image,
        phasesWithNames: phasesWithName,
        // phasesWithNames: ["phase1","phase2","phase3"],
        phaseArr:phaseArr,
        // phase:{selectedPhase:activePhase?activePhase:phaseArr[0],phaseName:phaseName}
      };
      console.log("program", _program);

      if (from === "coach" || !user.admin) {
        // debugger
        if (update) {
          _program.last_updated = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            // debugger
            // console.log("id_where_code_breaking",props.location.state.program.id);
            // console.log("loging bug", {
            // duplicate:duplicate,
            // _program:_program,
            // addWorkout:addWorkout,
            // submitWorkout:submitWorkout,
            // noRefresh:noRefresh})
            updateProgramCoach(
              user.id,
              _program,
              props.location.state.program.id,
              (result) => {
                console.log("callback result",result)
                saveCallback(
                  result,
                  duplicate,
                  _program,
                  addWorkout,
                  submitWorkout,
                  noRefresh
                );
                
                setReloadWorkout(!reloadWorkout);
              }
            );
          });
        } else {
          debugger
          _program.created = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addProgramCoach(user.id, _program, (result) => {
              saveCallback(
                result,
                duplicate,
                _program,
                addWorkout,
                submitWorkout,
                noRefresh
              );
              setReloadWorkout(!reloadWorkout);
            });
          });
        }
      } else {
        if (update) {
          _program.last_updated = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            updateProgramAurum(
              _program,
              props.location.state.program.id,
              (result) => {
                saveCallback(
                  result,
                  duplicate,
                  _program,
                  addWorkout,
                  submitWorkout,
                  noRefresh
                );
                setReloadWorkout(!reloadWorkout);
              }
            );
          });
        } else if (props.location.state.copy) {
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addProgramCoach(user.id, _program, (result) => {
              saveCallback(
                result,
                duplicate,
                _program,
                addWorkout,
                submitWorkout,
                noRefresh
              );
              setReloadWorkout(!reloadWorkout);
            });
          });
        } else {
          _program.created = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addProgramAurum(_program, (result) => {
              saveCallback(
                result,
                duplicate,
                _program,
                addWorkout,
                submitWorkout,
                noRefresh
              );
              setReloadWorkout(!reloadWorkout);
            });
          });
        }
      }
    }
  }

  function onSubmitWorkout(programId, _program) {
    
    debugger
    if (programId) {
      // debugger
      setIsProgramId(programId)
      console.log("heb al een id");

      let workout = allWorkouts.filter((item) => item.name === addWorkoutDrop);
      // console.log(workout);
      let _workout = { ...workout[0], phase: activePhase };

      getWorkoutsAurum((result) => {
        setAllWorkouts(result);
        let titles = [];
        if (result) {
          result.forEach((element) => {
            titles.push(element.name);
          });
        }

        setAllWorkoutsTitles(titles);
      });
      const historyBrowser = createBrowserHistory({
        basename: process.env.PUBLIC_URL,
        forceRefresh: true,
      });
      if (from === "coach" || !user.admin) {
      // if (from === "coach" || !user.admin || user.admin) {
        if (programId) {
          debugger
          _workout.created = new Date();
          console.log("maak aan");
          if (update) {
            addProgramWorkoutCoach(user.id, _workout, programId, (result) => {
              debugger
              // console.log("addProgramWorkoutCoach", result);
              // saveCallback(result, true, _workout)
              setReloadWorkout(!reloadWorkout)
              // console.log(_program);
              props.history.push("/program", {
                update: true,
                from: from,
                program: programId?.id
                  ? { ..._program, id: programId }
                  : props.location.state.program,
              });
            });
          } else {
            addProgramWorkoutCoach(user.id, _workout, programId, (result) => {
              debugger
              // console.log(result);
              // saveCallback(result, true, _workout)
              // setReloadWorkout(!reloadWorkout);
              setReloadWorkout(true);
              // console.log(_program);
              props.history.push("/program", {
                update: true,
                from: from,
                program: programId
                  ? { ..._program, id: programId }
                  : props.location.state.program,
              });
            });
          }
          setReloadWorkout(!reloadWorkout);
        }
      } else {
        if (programId) {
          _workout.created = new Date();
          console.log(
            "maak aan",
            _workout,
            programId?.id ? programId.id : props.location.state.program.id
          );

          addProgramWorkoutAurum(
            programId?.id ? programId.id : props.location.state.program.id,
            _workout,
            (result) => {
              // console.log(result);
              // saveCallback(result, duplicate, _workout)
              setReloadWorkout(!reloadWorkout);
              // console.log(_program);
              historyBrowser.push("/program", {
                update: true,
                from: from,
                program: programId?.id
                  ? { ..._program, id: programId.id }
                  : props.location.state.program,
              });
            }
          );
          setReloadWorkout(!reloadWorkout);
        }
      }
      initiateLoading("save", false);
      setReloadWorkout(!reloadWorkout);
    } else {
      console.log("we doen submit");
      onSubmit(false, false, true);
    }
  }

  async function saveCallback(
    result,
    duplicate,
    _program,
    addWorkout,
    submitWorkout,
    noRefresh
  ) {
    // console.log("resssss",result, duplicate, _program, addWorkout, submitWorkout);
    if (submitWorkout) {
      // console.log("loop Submit workout");
      onSubmitWorkout(result, _program);
    } else if (noRefresh && result) {
      console.log("noRefresh");
      props.history.push("/program", {
        update: true,
        from: from,
        program: props.location.state.program,
      });
      setLoading(false);
    } else if (!addWorkout && result) {
      if (duplicate) {
        props.history.push("/program", {
          update: false,
          copy: true,
          from: from,
          exercise: _program,
        });
      } else {
        props.history.push("/programs");
      }
    } else if (addWorkout) {
      debugger
      props.history.push("/workout", {
        update: false,
        from: from,
        phase: activePhase,
        programID: props.location.state.program?.id
          ? props.location.state.program.id
          : result,
      });
    } else {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({
        type: "default",
        message: "An unexpected error occurred while adding this exercise.",
      });
    }
  }

  // function capture(video, scaleFactor) {
  //   if(scaleFactor == null){
  //     scaleFactor = 1;
  //   }
  //   var w = video.videoWidth * scaleFactor;
  //   var h = video.videoHeight * scaleFactor;
  //   var canvas = document.createElement('canvas', {
  //     allowTaint: true,
  //     foreignObjectRendering: true
  // });
  //   canvas.width  = w;
  //   canvas.height = h;
  //   var ctx = canvas.getContext('2d');
  //     ctx.drawImage(video, 0, 0, w, h);
  //     return canvas;
  // }

  const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const onChange = (thumbnail, pageType, storageUrl) => {
    let file = dataURLtoFile(thumbnail);
    console.log(file);
    // initiated()
    // acceptedFiles.map((file) => {
    if (file.type.split("/")[0] === "video") {
      if (file.type === "video/mp4") {
        const url = URL.createObjectURL(file);
        const video = document.createElement("video");
        video.onloadedmetadata = (evt) => {
          URL.revokeObjectURL(url);
          uploadToFirebase(file);
        };
        video.src = url;
        video.load(); // fetches metadata
      }
    } else {
      if (file.type === "image/jpeg" || file.type === "image/png") {
        // browserImageSize(file).then(function (size) {
        uploadToFirebase(file, pageType, storageUrl);

        // });
      }
    }
    // });
  };

  function removeWorkout(e) {
    deleteMediaArrayFromStorage([e.image], () => {
      if (from === "aurum") {
        deleteProgramWorkoutAurum(e.id, props.location.state.program.id, () => {
          props.history.go(0);
        });
      } else {
        deleteProgramWorkoutCoach(
          user.id,
          props.location.state.program.id,
          e.id,
          () => {
            props.history.go(0);
          }
        );
      }
    });
  }

  function uploadToFirebase(file, pageType, storageUrl) {
    Object.assign(
      file,
      storage.uploadMedia(
        file,
        pageType,
        storageUrl,
        (progress) => {
          // set_uploadProgress(progress);
        },
        (url, fileName) => {
          console.log(
            url.split(fileName)[0] + fileName.split(".png")[0] + "_562x1218.png"
          );
          setImage(url);
        },
        (err) => {
          // set_wrongFormat("Something went wrong, contact administrator.");
          console.error(
            "error defining media, function:  uploadToFirebase ",
            err
          );
        }
      )
    );
  }

  function generateThumbnails() {
    let videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      // bucket
      let bucket;
      // fullPath
      let fullPath = video.getAttribute("src");
      // contentType
      let contentType = "video/mp4";

      let data = {
        bucket: bucket,
        fullPath: fullPath,
        contentType: contentType,
      };
    });
  }
  let addPhasehandel = () => {
    let arr = JSON.parse(localStorage.getItem("arr") || `[]`);
    let phaseObj = {
      phaseName: phaseName,
      weeks: weeks,
      phases: phases,
    };
    arr.push(phaseObj);
    localStorage.setItem("arr", JSON.stringify(arr));
    // console.log("arrr", JSON.parse(localStorage.getItem("arr")));
    setPhaseArr(JSON.parse(localStorage.getItem("arr")));
  };
  const handelPhaseChanged = (e) => {
    let oldOne = phases;
    localStorage.setItem("oldVal", oldOne);
    // console.log("e phase changed value", e);
    let parsedVal = parseInt(e);
    // console.log("parsed val", parsedVal, oldOne);
    if (parsedVal > localStorage.getItem("oldVal")) {
      // console.log("increaseing");
      localStorage.setItem("oldVal", parsedVal);
      setPhases(e);
      setPhaseChanged(e);

      const _inputs = [...inputs];

      _inputs.push({});
      setInputs(_inputs);
    } else {
      // setPhases(e);
      //   setPhaseChanged(e)
      setPhases(e);
      setPhaseChanged(e);
      const input = [...inputs];
      input.splice(0, 1);
      setInputs(input);
      // setDel(true)
      // setPhases(input.length)
      // console.log("decreaseing");
      // console
    }

    //   setPhases(e);
    //   setPhaseChanged(e)

    //   const _inputs = [...inputs];

    //   _inputs.push({});
    // setInputs(_inputs);
  };
  // useEffect(()=>{

  // },[])
  const deleteField = (idx) => {
    // console.log("delete feild key", idx);
    // let phaseNum=phases
    // phaseNum--
    // phases-=1
    const input = [...inputs];
    input.splice(idx, 1);
    setInputs(input);
    // setDel(true)
    setPhases(input.length);
    // phases-=1;

    // console.log("Inputs field", inputs);
  };

  // useEffect(()=>{
  //   // console.log("inputref",inputRef)
  //   if(props.location.state.update||props.location.state.copy){
  //     console.log("nothing push")
  //   }else{
  //     if(phases>1){
  //       const _inputs = [...inputs];
  //       // for(let i=0; i<phases; i++){

  //       // }

  //       _inputs.push({});
  //     setInputs(_inputs);
  //     // setPhases(_inputs.length)

  //     }
  //   }

  //     },[phases])
  const handelActivePhase = (e) => {
    setActivePhase(e);
    setPhase("");
    setOpen(false)
    
  };
  // const savePhasesName=()=>{
  //   console.log("name added",phaseArr,activePhase?activePhase:phaseArr[0])
  //   // phaseArr.splice(0,1,phase)
  //   // setPhaseArr(phaseArr)
  //     const phasesArrTempStorage=JSON.parse(localStorage.getItem("phasesArr")||`[]`)
  //   // phasesArrTempStorage=[...phaseArr]
  //   let phaseIndex=phaseArr.indexOf(activePhase?activePhase:phaseArr[0])
  //   phaseArr.splice(phaseIndex,1,phase)
  //     phasesArrTempStorage.splice(phaseIndex,1,phase)
  //   // phasesArrTempStorage=[...phasesArrTempStorage,phaseArr]
  //     localStorage.setItem("phasesArr",JSON.stringify(phaseArr))
  //   setActivePhase(phase)
  //       let tempStoredPhase=JSON.parse(localStorage.getItem("phasesArr"))
  //   console.log("phshsabjdasb",tempStoredPhase)
  //   setPhaseArr(phaseArr)
  //   console.log("phase", phaseIndex)
  // }
  useEffect(()=>{
    // console.log("phase name",phasesWithName)
    if(phasesWithName.length>0){
      let filterOutPhaseName=phasesWithName.filter((ph)=>ph.phaseArrIdx==phaseArr.indexOf(activePhase))
      // console.log("filter phase",filterOutPhaseName,phasesWithName.indexOf(filterOutPhaseName[0]))
      const phasesWithNameIdx=phasesWithName.indexOf(filterOutPhaseName[0]);
      if(filterOutPhaseName.length>0){
        // let obj={
        //   phaseName:filterOutPhaseName[0].phaseName,
        //   phaseArrIdx:filterOutPhaseName[0].phaseArrIdx,
        //   phase:activePhase,
        // }
        for(let i=0; i<phasesWithName.length; i++){
          let obj={
            phaseName:phasesWithName[i].phaseName,
            phaseArrIdx:phasesWithName[i].phaseArrIdx,
            phase:phaseArr[i],
          }
          phasesWithName.splice(i,1 ,obj)
          setPhaseWithName(phasesWithName)
        }
        // phasesWithName.splice(phasesWithNameIdx,1,obj)
        // setPhaseWithName(phasesWithName)
        // console.log("updated obj phases name",phasesWithName)
        setPhase(filterOutPhaseName[0].phaseName)
      }else{
        // console.log("do nothing")
      }
    }else{
      // console.log("weeks")
      // setActivePhase(false)
    }
  },[activePhase,weeks])
  const savePhasesName = () => {
    // debugger
    setOpen(true)
    setTimeout(()=>{
      setOpen(false)
    },1000)
    console.log("phassss",phaseArr)
    let idx=phaseArr.indexOf(activePhase)
    let objWithPhaseName={
      phaseName:phase,
      phaseArrIdx:phaseArr.indexOf(activePhase),
      phase:activePhase
    }
    // phasesWithName.splice(idx,1 ,objWithPhaseName)
    if(phaseArr.length!=phasesWithName.length){
        //add push operation when phasesWithName length is not equal to phaseArr length
        // let data =[]
        console.log("obj phase name",objWithPhaseName)
      phasesWithName.push(objWithPhaseName)
      // phasesWithName.push({
      //   phaseName:"phase",
      //   phaseArrIdx:1,
      //   phase:1
      // })
      // data.push(objWithPhaseName)
      
      console.log("name phase add",phasesWithName);
      setPhaseWithName(phasesWithName)
      setSnackbarMessage("Phase name is added")
    }else{
      let filterOutExistingPhases=phasesWithName.filter((ph)=>ph.phase==activePhase)
      if(filterOutExistingPhases.length>0){
      let findIdx=phasesWithName.indexOf(filterOutExistingPhases[0])
      phasesWithName.splice(findIdx,1,objWithPhaseName)
      // phasesWithName.splice(findIdx,1,JSON.stringify(objWithPhaseName))
      setPhaseWithName(phasesWithName)
      // console.log("filter out Existinggg phase",filterOutExistingPhases,phasesWithName)
      setSnackbarMessage("Phase name is updated")
      }
      else{
        phasesWithName.push(objWithPhaseName)
        // console.log("name phase debugging add",phasesWithName);
        setPhaseWithName(phasesWithName)
        console.log("debugging")
        setSnackbarMessage("Phase name is updated")
      }
    }
    // setPhase("")
  };
  return (
    <>
     <SnackBar
        open={open}
        message={snackbarMessage}
        position='top-right'
        // type="info"
        // yesLabel='Ok'
        timeout={1000}
        // onYes={()=>{}}
        // color="#696969"
        containerStyle={SnackBarStyle}
        closeOnClick={true}
      />
      <div className="c-page-wrapper" style={{ flexFlow: "column" }}>
        <Header
          title={isAdmin && update ? "Update Program" : "Add Program"}
          subtitle={true}
        />
        <div style={{ display: "flex" }}>
          <div className="c-page-main c-define-page c-define-wrapper">
            {isAdmin ? (
              <>
                <div
                  className="c-image-collection"
                  style={{ width: "100%", display: "flex" }}
                >
                  <div className="c-image">
                    <span style={{ fontSize: 16, marginTop: -1 }}>Banner</span>
                    <DefineMedia
                      isAdmin={isAdmin}
                      error={
                        error && error.type === "image" ? error.message : false
                      }
                      media={image}
                      pageType={"image"}
                      storageUrl={`${
                        from === "coach" ? "coach/" + user.id : "aurum"
                      }/programs/`}
                      onMediaChange={(e) => setImage(e)}
                      addToDeleteUrl={addToDeleteUrl}
                    />
                    <p className="c-image-sub">Cover image</p>
                    {isAdmin && <p className="c-pixels">800 x 800 pixels</p>}
                  </div>
                  <div style={{ width: "100%", paddingTop: 20 }}>
                    <Input
                      placeholder="Full name of program"
                      error={
                        error && error.type === "name" ? error.message : false
                      }
                      label={`Name${isAdmin ? "*" : ""}`}
                      value={name}
                      onChange={(e) => setName(e)}
                    />
                    <Textarea
                      placeholder="Short description of the excercise"
                      error={
                        error && error.type === "description"
                          ? error.message
                          : false
                      }
                      title={`Description${isAdmin ? "*" : ""}`}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 20,
                      alignItems: "center",
                    }}
                  >
                    <Input
                      type={"number"}
                      min={1}
                      placeholder={1}
                      error={
                        error && error.type === "phases" ? error.message : false
                      }
                      label={`Phases${isAdmin ? "*" : ""}`}
                      value={phases}
                      onChange={(e) => {
                        handelPhaseChanged(e);
                      }}
                    />
                    <Input
                      type={"number"}
                      placeholder={1}
                      error={
                        error && error.type === "weeks" ? error.message : false
                      }
                      label={`Weeks${isAdmin ? "*" : ""}`}
                      value={weeks}
                      onChange={(e) => {
                        setWeeks(e);
                        setWeekChanged(e);
                        // setPhaseWithName([])
                      }}
                    />
                    {/* <Input type={"number"}  placeholder="Enter phase" error={error && error.type === "phases" ? error.message : false} label={`Phases${isAdmin ? "*" : ""}`} value={phases} onChange={(e) => {setPhases(e)}}/>
                    <Input type={"number"} placeholder="Enter week" error={error && error.type === "weeks" ? error.message : false} label={`Weeks${isAdmin ? "*" : ""}`} value={weeks} onChange={(e) => {
                      setWeeks(e)
                      // let arr=[]
                     
                      }}/> */}
                    {/* <div> */}
                    {/* <button onClick={addPhasehandel} style={{cursor:"pointer", color:"#fff", backgroundColor:"#00BDA5",height: "42px", width: "100px",borderRadius: "6px"}}  >Add Phase</button> */}
                    {/* <Button text="Add phase" color="#fff" backgroundColor="#00BDA5" onSubmit={addPhasehandel}  /> */}
                    {/* </div> */}
                  </div>
                  <div
                    style={{
                      position: "relative",
                      zIndex: 500000,
                      display: "flex",
                    }}
                  >
                    {/* client dropdown */}
                    <div
                      className="dorp-wrapper"
                      style={{ marginRight: "15px" }}
                    >
                      <Input
                        placeholder={"select"}
                        // options={JSON.parse(localStorage.getItem("phaseArr"))}
                        options={phaseArr}
                        type={"select"}
                        error={
                          error && error.type === "weeks"
                            ? error.message
                            : false
                        }
                        label={`Select Phase${isAdmin ? "*" : ""}`}
                        value={activePhase}
                        onChange={(e) => {
                          // setActivePhase(e);
                          handelActivePhase(e);
                          // let phases=JSON.parse(localStorage.getItem("phasesWithNames"))||[]
                          // phases.push(phasesArrayOfObj[0])
                          // localStorage.setItem("phasesWithNames",JSON.stringify(phases))
                        }}
                      />
                      {/* <label className="c-input-label">Select Phase</label> */}
                      {/* <Dropdown  options={phaseArr}  arrowClosed={<Icon icon="arrow-down" height={15} size={15} />}   onChange={(e) => {setActivePhase(e)
                    let phases=JSON.parse(localStorage.getItem("phasesWithNames"))||[]
                    phases.push(phasesArrayOfObj[0])
                    localStorage.setItem("phasesWithNames",JSON.stringify(phases))
                    let obj={phase:e,phaseName:phaseName}
                    phasesArrayOfObj.push(obj)
                    setPhasesArrayOfObj(phasesArrayOfObj)
                    console.log("pahses array with names",phasesArrayOfObj)
                    }}/> */}
                      {/* <label>Select Pha</label> */}
                      {/* <select placeholder="Select" className="custom-dropdown" onChange={(e) => {setActivePhase(e.target.value)
                    
                    let obj={phase:e.target.value,phaseName:phaseName}
                    phasesArrayOfObj.push(obj)
                    setPhasesArrayOfObj(phasesArrayOfObj)
                    console.log("pahses array with names",phasesArrayOfObj)
                    }} >
                      <option>Select</option>
                      {
                        phaseArr.map((data)=>{
                          return <option>{data}</option>
                        })
                      }
                    </select> */}
                    </div>
                  </div>
                  {
                    activePhase?
                    <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "30px",
                    }}
                    id="custom-input"
                  >
                    
                    <label className="phase-name-label">
                    Name Selected Phase
                    </label>
                    <input
                      className="phase-name-input"
                      name="phase"
                      value={phase}
                      placeholder="Name selected phase"
                      onChange={(e) => setPhase(e.target.value)}
                    />
                    <span className="hover-text" style={{position:"relative"}}>
                      <button
                        disabled={phase?false:true}
                        className="save-phase-icon "
                        onClick={savePhasesName}
                      >
                        {/* <Icon icon="save-phase" /> */}
                        <IoAddCircle    size={30} color={phase?"rgb(0, 189, 165)":"black"}  />
                      </button>
                      <span className="tooltip-text" id="bottom">
                        Add name to selected phase
                      </span>
                    </span>
                  </div>:""
                  }
                  
                  {workouts.length > 0 && (
                    <LongList
                      from={from}
                      phase={activePhase}
                      // phase={"Week 1 - 1"}
                      program={props.location.state.program.id}
                      pagetype="workout"
                      history={props.history}
                      items={workouts ? workouts : []}
                      removeItem={(e) =>
                        setShowPopup({ type: "workout", ...e })
                      }
                    />
                  )}
                  <hr
                    style={{
                      marginBottom: 30,
                      marginTop: 20,
                      backgroundColor: "#97a9bc",
                      height: 1,
                      border: "none",
                    }}
                  />
                  <label>
                    <strong>Select workout or add new workout</strong>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 5,
                      flexDirection: "column",
                      alignItems: "left",
                    }}
                  >
                    {/* {console.log(weekChanged, phaseChanged)} */}
                    {weekChanged === false||true && phaseChanged === false||true ? (
                      <>
                        <div
                          className="workout-select-1"
                          style={{
                            width: 500,
                            backgroundColor: "#dbe0ea",
                            padding: 15,
                            borderRadius: 12,
                          }}
                        >
                          <Input
                            type="select"
                            label={` `}
                            value={addWorkoutDrop}
                            options={allWorkoutsTitles}
                            onChange={(e) => setAddWorkoutDrop(e)}
                          />
                          {/* <Input type="select" label="Category" value={category} options={categories} onChange={(e) => setCategory(e)} /> */}
                          <AddButton
                            text="Add selected workout"
                            backgroundColor="#FFFFFF"
                            color="#000"
                            onClick={(e) => {
                              onSubmitWorkout(props.location.state.program?.id);
                            }}
                          />
                        </div>

                        <div
                          className="workout-select-1"
                          style={{
                            width: 500,
                            backgroundColor: "#dbe0ea",
                            padding: 15,
                            borderRadius: 12,
                          }}
                        >
                          <AddButton
                            text="Add new workout"
                            backgroundColor="#FFC415"
                            color="#000"
                            onClick={(e) => {
                              e.preventDefault();
                              onSubmit(false, true);
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <p>
                        You need to save your program before you can add new
                        workouts.
                      </p>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="c-no-admin-input-replace">
                  <span>Name</span>
                  <p>{name}</p>
                </div>
                <div className="c-no-admin-input-replace">
                  <span>Description</span>
                  <p>{description}</p>
                </div>
              </>
            )}
            <div className="c-select-collection">
              {/* {isAdmin ? (
                <>
                  <Input type="select" label="Category" value={category} options={categories} onChange={(e) => setCategory(e)} />
                  <Input type="select" label="Excercise starts with" value={startsWith} options={starts_with_options} onChange={(e) => setStartsWith(e)} />
                </>
              ) : (
                <>
                  <div className="c-no-admin-input-replace">
                    <span>Category</span>
                    <p>{category}</p>
                  </div>
                  <div className="c-no-admin-input-replace">
                    <span>Excercise starts with</span>
                    <p>{startsWith}</p>
                  </div>
                </>
              )} */}
            </div>

            {/* <div className="c-select-collection">
              {isAdmin ? (
                <Input label="Tags" type="multi" tags={selectedTags} options={tags} onRemove={(e) => onDelete(e)} onSelect={(e) => onAddition(e)} onChange={(e) => addTagToDropdown(e)} />
              ) : (
                <div className="c-coach-pills-wrapper c-tags-grid-position">
                  <span>Tags</span>
                  <ul className="c-coach-pills">
                    {selectedTags.map((tag, idx) => (
                      <li key={idx}>{tag.name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div> */}

            {showPopup && (
              <Popup
                title={"Delete workout"}
                button="Delete"
                deletePopup={true}
                description={
                  "Are you sure you want to delete this workout? This can not be undone."
                }
                onAction={() => removeWorkout(showPopup)}
                onCancel={() => {
                  setShowPopup(false);
                }}
              />
            )}

            {isAdmin && (
              <>
                {error && (
                  <p className="c-default-error-message">{error.message}</p>
                )}
                <div
                  className="c-button-collection"
                  style={{ alignItems: "center" }}
                >
                  <Button
                    text="Save"
                    color="#fff"
                    backgroundColor="#00BDA5"
                    onSubmit={() => onSubmit(false)}
                    loading={loading}
                  />
                  {/* <Button text="Save and add another" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(true)} loading={loadingDuplicate} /> */}
                  <p
                    className="c-cancel-button"
                    onClick={() => props.history.push("/programs")}
                  >
                    Cancel
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {openVideoModal && (
        <VideoPlayer toggleModal={toggleModal} videoPath={videoPath} />
      )}
    </>
  );
}

export default DefineProgram;
